import z from "zod";

const translationPath = "page.settings.crm.sendLimitMonths.errors.";

const ticketServiceSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "ticket_service" }
);

export const sendLimitMonthsSchema = z
  .object({
    enable: z.boolean(),
    name: z.string().min(1, { message: translationPath + "name" }),
    ticketService: ticketServiceSchema,
    startDate: z.date({ invalid_type_error: translationPath + "start_date" }),
    endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
    valueLimit: z.string().min(1, {
      message: translationPath + "value_limit",
    }),
    alertPercentLimit: z
      .string()
      .refine((val) => !val || (Number(val) >= 0 && Number(val) <= 100), {
        message: "O valor deve estar entre 0 e 100",
      })
      .nullish(),
    alertMail: z.string().min(1, {
      message: translationPath + "alert_mail",
    }),
    description: z.string().nullish(),
  })
  .superRefine((val, ctx) => {
    if (val.endDate < val.startDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["endDate"],
        message: translationPath + "end_date_less",
      });
    }
  });

export type TSendLimitMonths = z.infer<typeof sendLimitMonthsSchema>;
